var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-inline-block settings-button",on:{"click":_vm.createFile}},[_vm._v(_vm._s(_vm.$t('Export instances')))]),(_vm.msg)?_c('div',{staticClass:"form-error mt-1"},[_vm._v(_vm._s(_vm.msg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }